const DEFAULT_API_PATH = '/api'

const resolveBaseUrl = (envValue: string | undefined, fallbackPath: string) => {
  if (envValue && envValue.trim().length > 0) {
    return envValue.trim().replace(/\/+$/, '')
  }

  // Hardcoded fallback to production backend URL when environment variable is not set
  if (typeof window !== 'undefined' && window.location) {
    // If running on pages.dev, use the production backend URL
    if (window.location.hostname.includes('pages.dev')) {
      return 'https://rwachat.webnetworksolution.com'
    }
    return `${window.location.origin}${fallbackPath}`
  }

  return fallbackPath
}

const apiBaseUrl = resolveBaseUrl(import.meta.env.VITE_API_BASE_URL, DEFAULT_API_PATH)
const wsBaseUrl = resolveBaseUrl(import.meta.env.VITE_WS_BASE_URL, `${DEFAULT_API_PATH}/ws`)

export const env = {
  apiBaseUrl,
  wsBaseUrl,
  environment: import.meta.env.MODE,
  appVersion: import.meta.env.VITE_APP_VERSION ?? 'dev',
}

export const buildWsUrl = (path: string) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (wsBaseUrl.startsWith('ws://') || wsBaseUrl.startsWith('wss://')) {
    return `${wsBaseUrl}${normalizedPath}`
  }

  const apiUrl = apiBaseUrl.startsWith('http')
    ? apiBaseUrl
    : `${window.location.protocol}//${window.location.host}${apiBaseUrl.startsWith('/') ? '' : '/'}${apiBaseUrl}`

  const wsScheme = apiUrl.startsWith('https') ? 'wss' : 'ws'
  const trimmedApiUrl = apiUrl.replace(/^https?:\/\//, '')

  return `${wsScheme}://${trimmedApiUrl}${normalizedPath}`
}
